import { Theme, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { formatDistanceToNow } from 'date-fns';
import fileSize from 'filesize';
import { FC } from 'react';
import {
  FaFile,
  FaCompass,
  FaCalendar,
  FaCodeBranch,
  FaLock,
  FaUserFriends,
} from 'react-icons/fa';
import { FiHash } from 'react-icons/fi';
import GeneralInfoSection from './GeneralInfoSection';

const GeneralInfo: FC<React.PropsWithChildren<GeneralInfoPropTypes>> = ({
  developers,
  files,
  repoSize,
  lastCodeChangedString,
  lastCodeChanged,
  createdAt,
  accessLevel,
  monoRepoParent,
  isMonoRepoChild,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.generalInfo}>
      <GeneralInfoSection
        title='Developers'
        icon={FaUserFriends}
        value={developers.toLocaleString()}
      />
      <GeneralInfoSection
        title='File Count'
        icon={FaFile}
        value={files.toLocaleString()}
      />
      <GeneralInfoSection
        title='Repo Size'
        icon={FiHash}
        value={fileSize(repoSize)}
      />
      <GeneralInfoSection
        title='Last Code Change'
        icon={FaCompass}
        value={
          lastCodeChangedString && lastCodeChangedString !== 'N/A' ? (
            <Tooltip
              title={lastCodeChanged ? lastCodeChanged.toLocaleString() : 'N/A'}
              arrow
              placement='right'>
              <span>{lastCodeChangedString} ago</span>
            </Tooltip>
          ) : (
            <span>Not Available</span>
          )
        }
      />
      <GeneralInfoSection
        title='Creation Date'
        icon={FaCalendar}
        value={
          <Tooltip
            title={new Date(Number(createdAt)).toLocaleString()}
            arrow
            placement='right'>
            <span>{formatDistanceToNow(new Date(Number(createdAt)))} ago</span>
          </Tooltip>
        }
      />
      <GeneralInfoSection
        title='Access Level'
        icon={FaLock}
        value={accessLevel}
      />
      {isMonoRepoChild && (
        <GeneralInfoSection
          title='Parent Monorepo'
          icon={FaCodeBranch}
          value={monoRepoParent}
        />
      )}
    </div>
  );
};

export interface GeneralInfoPropTypes {
  developers: number;
  files: number;
  repoSize: number;
  lastCodeChangedString?: string;
  lastCodeChanged?: Date;
  createdAt: string;
  accessLevel: string;
  monoRepoParent: string;
  isMonoRepoChild: boolean;
}

const useStyles = makeStyles()((theme: Theme) => ({
  generalInfo: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export default GeneralInfo;
